module.exports = __webpack_public_path__ + "img/gdq_gbt853_1988.prt.41584a6f.jpg";